import { Accordion, AccordionDetails, AccordionSummary, Box, Divider, Typography } from '@mui/material';
import { StatusDot } from '../StatusDot';
import type { AccordionPanelProps } from './AccordionPanel.types';

export function AccordionPanel({
  children,
  contentStyles,
  defaultExpanded = false,
  divider = false,
  expanded,
  title,
  dotColor,
  onChange,
  sx,
}: AccordionPanelProps) {
  return (
    <Accordion defaultExpanded={defaultExpanded} expanded={expanded} onChange={onChange} sx={sx}>
      <AccordionSummary>
        <Box display="flex" alignItems="center" gap={1}>
          {dotColor && (
            <Box data-testid="accordion-status-dot" aria-hidden="true" display="flex">
              <StatusDot color={dotColor} />
            </Box>
          )}
          <Typography variant="subtitle2" color="text.primary">
            {title}
          </Typography>
        </Box>
      </AccordionSummary>
      {divider && <Divider />}
      <AccordionDetails sx={contentStyles}>{children}</AccordionDetails>
    </Accordion>
  );
}
